export const ADMIN_ACCOUNT_LOGIN = "auth/login";
export const ADMIN_REFRESH_TOKEN = "auth/refresh";
export const ADMIN_FORGOT_PASSWORD = "auth/forgot-password";
export const ADMIN_RESET_PASSWORD = "auth/reset-password";
export const UPDATE_PROFILE = "users/update-profile";
export const UPDATE_PROFILE_IMAGE = "users/update-profile-image";
export const UPDATE_PASSWORD = "users/update-password";
export const VERIFY_OTP = "otp/verify";
export const GET_PROFILE = "users/detail";
export const GET_SETTING = "settings";
export const UPDATE_SETTING_LOGO = "settings/logo";
export const GET_EMAIL = "email-template";
export const GET_NOTIFICATION_TEMPLATE = "notification-template";
export const GET_SMS = "sms-template";
export const GET_PAGE = "page";
export const GET_FAQ = "faq";
export const GET_BLOG = "blog";
export const GET_BANNER = "banner";
export const BLOG_IMAGE_UPLOAD = "blog/image";
export const GET_CMS_MENU = "cms-menu";
export const GET_REPORT_ISSUE = "report-issue";
export const GET_CONTACT_ENQUIRY = "contact-enquiry";
export const GET_TRIP_CANCEL_MANAGER = "trip-cancel-options";
export const GET_ADMIN = "admin";
export const GET_CUSTOMER = "customer";
export const GET_DRIVER = "driver";
export const GET_DRIVER_DETAILS = "driver-details";
export const GET_LANGUAGE = "language";
export const GET_VEHICLE_TYPE = "vehicle-type";
export const GET_FUEL_TYPE = "fuel-type";
export const GET_RIDE_TYPE = "ride-type";
export const GET_RIDE_CATEGORY = "vehicle-category";
export const GET_VEHICLE_TYPE_LIST = "vehicle-type/list";
export const GET_FUEL_TYPE_LIST = "fuel-type/list";
export const GET_RIDE_TYPE_LIST = "ride-type/list";
export const GET_VEHICLE_CATALOG = "vehicle-catalog";
export const GET_RIDE_CATEGORY_LIST = "vehicle-category/list";
export const GET_TRAINING = "training";
export const GET_WALLET = "wallet";
export const GET_NOTIFICATION = "notification/send-bulk-notification";
export const GET_ADMIN_NOTIFICATIONS = "notification/admin/list";
export const MARK_ADMIN_NOTIFICATIONS_READ = "notification/admin/mark-read";
export const GET_VEHICLE = "vehicle";
export const GET_VEHICLE_LIST = "vehicle/list";
export const GET_PROMO_CODE = "promo-code";
export const GET_STATE_MANAGEMENT = "state-management";
export const GET_STATE_MANAGEMENT_LIST = "state-management/list";
export const GET_GEO_FENCE = "geo-fence";
export const GET_BOOKING = "booking";
export const GET_REVIEW = "review/admin";
export const GET_DRIVER_REPORT = "driver-report";
export const GET_TRANSACTION = "transaction";
export const GET_WITHDRAWAL = "withdrawal/admin";
export const GET_DASHBOARD = "dashboard";
export const GET_SAFETY = "safety";
